import React, { useState, useEffect } from "react";
import bridge from "@vkontakte/vk-bridge";
import View from "@vkontakte/vkui/dist/components/View/View";
import ScreenSpinner from "@vkontakte/vkui/dist/components/ScreenSpinner/ScreenSpinner";
import "@vkontakte/vkui/dist/vkui.css";
import Home from "./panels/Home";
import WidgetService from "./services/WidgetService";

const App = ({ appId, groupId, platform }) => {
  const [wgId, setWgId] = useState("");
  const [wgType, setWgType] = useState("");

  console.group("INFO");
  console.log(`appId: ${appId}}`);
  console.log(`groupId: ${groupId}}`);
  console.log(`platform: ${platform}}`);
  console.log(`wgType: ${wgType}}`);
  console.groupEnd();

  const [activePanel, setActivePanel] = useState("home");
  const [fetchedUser, setUser] = useState(null);
  const [popout, setPopout] = useState(<ScreenSpinner size="large" />);

  useEffect(() => {
    getSettings(appId, groupId);
  }, [appId, groupId]);
  const getSettings = (appId, groupId) => {
    if (groupId) {
      WidgetService.getSettings(appId, groupId).then((resp) => {
        console.warn(resp.result);
        if (resp && resp.result) {
          setWgId(resp.result.widgetId);
          setWgType(resp.result.widgetType);
        }
      });
    }
  };

  const closeErrorAlert = () => {
    setPopout(null);
    bridge.send("VKWebAppClose", { status: "failed" });
  };

  console.log("platform" + platform);

  return (
    <View activePanel={activePanel}>
      <Home
        id="home"
        fetchedUser={fetchedUser}
        wType={wgType}
        w={wgId}
        title={wgType == 'payment' ? 'Онлайн оплата' : wgType == 'schedule' ? 'Расписание занятий' : null}
        platform={platform}
      />
    </View>
  );
};

export default App;
